export default "__VITE_ASSET__XIJ5Ps_Z__"